<div class="form-floating-icon">
  @if (state() === 'submit') {
    <mwe-button-link
      [isDisabled]="disabled"
      [label]="submitLabel"
      [color]="'blue'"
      [dataTest]="'form-input-' + inputElem.name + '-submit'"
      (clicked)="submit()"
    />
  }

  @if (state() === 'loading') {
    <div class="loading-spinner"></div>
  }
</div>
